<template>
  <div id="soil-history" style="overflow: hidden;">
    <div v-if="soilLoadFlg" style="left: 40%; top: 30%; position:absolute; color: #5BF2FF">
      <dv-loading>Loading....</dv-loading>
    </div>
    <div class="soilHistory-data">
      <div class="soilHistory-data-head">
        <div class="soilHistory-head-title" >
          <span class="soilHistory-title-container">墒情历史数据</span>
        </div>

        <div class="soilHistory-head-select">
          <div class="soilHistory-select-device">
            <el-select @change="soilHistoryChange($event)" v-model="defaultSoilDevice" filterable :disabled="soilLoadFlg">
              <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in soilHistoryList">
                <span :class="item.state === 'red' ? 'red-circle' : 'green-circle'"></span>
                {{ item.name }}
              </el-option>
            </el-select>
          </div>

          <div class="soilHistory-select-attribute">
            <el-select @change="soilAttrChange($event)" v-model="defaultSoilAttr" filterable :disabled="soilLoadFlg">
              <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in soilAttrList">
              </el-option>
            </el-select>
          </div>


          <div class="soilHistory-select-time">
            <el-date-picker @change="soilSelectTime" v-model="defaultSoilTime" unlink-panels type="datetimerange" :picker-options="soilPickerOptions" align="right" :disabled="soilLoadFlg"
                            end-placeholder="结束日期" key="time" range-separator="至" start-placeholder="开始日期">
            </el-date-picker>
          </div>

          <div class="soilHistory-select-agg">
            <el-dropdown @command="soilSelectAgg" :disabled="soilLoadFlg">
              <span class="el-dropdown-link">
                {{soilAggValue}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
              <el-dropdown-menu slot="dropdown" >
                <el-dropdown-item command="1">最大值</el-dropdown-item>
                <el-dropdown-item command="2">最小值</el-dropdown-item>
                <el-dropdown-item command="3">平均值</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <div class="soilHistory-head-btn">
          <div class="soilHistory-head-btnContainer">
            <el-button type="primary" @click="soilQueryData()" :disabled="soilLoadFlg">查询</el-button>
            <el-button type="warning" @click="soilExportData()" :disabled="soilLoadFlg">导出</el-button>
            <el-button type="danger" @click="soilChangeChart()" :disabled="soilLoadFlg">{{soilChartName}}</el-button>
          </div>
        </div>

      </div>
      <div class="soilHistory-data-content" style="overflow: auto;">
        <div class="soilHistory-content-table" v-show="soilChartNum == 1 ? true : false">
          <el-table :data="soilTableData.slice((soilCurrentPage-1)*soilPageSize,soilCurrentPage*soilPageSize)" border>
            <el-table-column prop="ts" label="日期" style="width: 40%"></el-table-column>
            <el-table-column prop="name" label="名称" style="width: 30%"></el-table-column>
            <el-table-column prop="value" label="值" style="width: 30%"></el-table-column>
          </el-table>
          <el-pagination @size-change="soilSizeChange" @current-change="soilCurrentChange" :current-page="soilCurrentPage" style="text-align: center; margin-top: 0.3%"
                         :page-sizes="[15, 30, 50, 100]"  :page-size="soilPageSize" layout="total, sizes, prev, pager, next, jumper" :total="soilTableData.length">
          </el-pagination>
        </div>

        <div class="soilHistory-content-chart" v-show="soilChartNum == 2 ? true : false">
          <div class="soilProChart" id="soilChart">
            <img src="../img/bg1.png" v-show="!soilShow">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment"
  import {getTimeDeviceHistory} from "../../until/api/MeteSoil";
  export default {
    name: 'SoilHistoryData',
    components: {},
    data() {
      return {
        soilDeviceList: [],
        soilHistoryList: [],
        defaultSoilDevice: '',
        soilAttrList: [],
        defaultSoilAttr: '',
        defaultSoilTime: [moment().format("YYYY-MM-DD HH:mm:ss"), moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm:ss")],
        soilPickerOptions: {
          shortcuts: [
            {
              text: '最近一天',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        },
        startTime: '',
        endTime: '',
        soilAggSelect: '1',
        soilAggValue: '最大值',
        soilAgg: '',
        soilInterval: '',
        soilChartNum: 1,
        soilChartName: '折线图',
        soilDeviceId: {},
        soilTableData:[],
        soilTimeValue:[],
        soilDataValue:[],
        soilShow: false,
        soilOption: {},
        soilCurrentPage: 1,
        soilPageSize: 15,
        //soilErrorNum: 0,
        soilLoadFlg: false,
      }
    },

    mounted() {
      //获取用户等级
      //let authority = this.$route.params.authority === undefined ? localStorage.getItem('authority') : this.$route.params.authority;
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      //获取用户id
      //let customerId = this.$route.params.customerId === undefined ? localStorage.getItem('customerId') : this.$route.params.customerId;
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')): this.$route.params.customerId;

      let that = this;
      this.$MeteSoilCommon.getDeviceList(authority, customerId, function (deviceList) {//获取用户设备
        that.soilHistoryDeviceBoards(deviceList);//获取墒情设备列表
      })
    },

    methods: {
      /**
       * 获取墒情设备列表
       * @type {*[]}
       */
      soilHistoryDeviceBoards(response) {
        // this.soilDeviceList = [];
        // if(response.data.length === 0) return;
        // for(let i = 0; i < response.data.length; i++) {
        //   let soilJson = {};
        //   soilJson.id = response.data[i].id.id;
        //   soilJson.name = response.data[i].name;
        //   soilJson.type = response.data[i].id.entityType;
        //   this.soilDeviceList.push(soilJson);
        // }
        // if(this.soilDeviceList.length > 0) {
        //   this.defaultSoilDevice = this.soilDeviceList[0].id;
        //   //获取墒情设备属性
        //   this.soilHistoryAttr();
        // }
        this.soilDeviceList = [];
        if(response.data.length === 0) return;
        let promises = [];
        for(let i = 0; i < response.data.length; i++) {
          let soilJson = {
            id: response.data[i].id.id,
            name: response.data[i].name,
            type: response.data[i].id.entityType
          };

          let promise = this.$MeteSoilCommon.getLastConnectTime(soilJson.type, soilJson.id).then(time => {
            let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
            soilJson.state = time < beforeTime ? 'red' : 'green';
            return soilJson;
          });

          promises.push(promise);
        }

        Promise.all(promises).then(result => {
          this.soilDeviceList = result;
          if(this.soilDeviceList.length > 0) {
            this.soilHistoryDevice(0, this.soilDeviceList.length)
          }
        })
      },

      soilHistoryDevice(j, length) {
        let that = this;
        this.$MeteSoilCommon.getCredentialsInfo(this.soilDeviceList[j].id, function (deviceInfo) {
          that.$MeteSoilCommon.getDeviceKeyList(deviceInfo, function (keyData) {
            that.soilKeyOperate(j, keyData);
            if(++j < length) {
              that.soilHistoryDevice(j, length);
            }
          })
        })
      },

      soilKeyOperate(j, keyData) {
        let strKey = '';
        let keyList = keyData.split(',');
        for(let i = 0; i < keyList.length; i++) {
          if(keyList[i].indexOf('soil') >= 0) {
            i == keyList.length -1 ? strKey += keyList[i] : strKey += keyList[i] + ',';
          }
        }
        if(strKey != '') {
          this.soilHistoryList.push(this.soilDeviceList[j]);

          if(this.defaultSoilDevice == '') {
            this.defaultSoilDevice = this.soilHistoryList[0].id;
            //获取墒情设备属性
            this.soilHistoryAttr();
          }
        }
      },

      /**
       * 切换墒情设备
       * @param event
       */
      soilHistoryChange(event) {
        this.defaultSoilDevice = event;
        this.setEmptySoilOption();//清空折线图
        this.soilTableData = [];
        this.soilTimeValue = [];
        this.soilDataValue = [];
        //获取墒情设备属性
        this.soilHistoryAttr();
      },

      /**
       * 获取墒情设备属性
       */
      soilHistoryAttr() {
        this.soilAttrList = [];
        this.defaultSoilAttr = '';
        let that = this;
        this.$MeteSoilCommon.getCredentialsInfo(this.defaultSoilDevice, function (deviceInfo) {//获取设备信息
          that.soilDeviceId = deviceInfo;
          that.$MeteSoilCommon.getDeviceKeyList(deviceInfo, function (keyData) {//获取墒情属性key
            let keyList = keyData.split(',');
            //筛选墒情
            for(let i = 0; i < keyList.length; i++) {
              if(keyList[i].indexOf('soil') >= 0) {
                let keyJson = {};
                keyJson.id = keyList[i];
                keyJson.name = that.$t(keyList[i]).split(',')[0];
                that.soilAttrList.push(keyJson);
              }
            }
            that.soilAttrList.length == 0 ? that.defaultSoilAttr = '' : that.defaultSoilAttr = that.soilAttrList[0].id;
          });
        });
      },

      /**
       * 切换墒情属性
       * @param event
       */
      soilAttrChange(event) {
        this.defaultSoilAttr = event;
        this.setEmptySoilOption();//清空折线图
        this.soilTableData = [];
        this.soilTimeValue = [];
        this.soilDataValue = [];
      },

      /**
       * 获取时间戳
       * @param val
       */
      soilSelectTime(val) {
        if(val === null) {
          this.defaultSoilTime = [moment().format("YYYY-MM-DD HH:mm:ss"), moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm:ss")];
          this.startTime = '';
          this.endTime = '';
        } else {
          this.startTime = new Date(val[0]).getTime();
          this.endTime = new Date(val[1]).getTime();
        }
      },

      /**
       * 切换聚合函数
       * @param event
       */
      soilSelectAgg(event) {
        switch (event) {
          case "1":
            this.soilAggSelect = "1";
            this.soilAggValue = "最大值";
            break;
          case "2":
            this.soilAggSelect = "2";
            this.soilAggValue = "最小值";
            break;
          case "3":
            this.soilAggSelect = "3";
            this.soilAggValue = "平均值";
            break;
        }
      },

      /**
       * 查询历史数据
       */
      soilQueryData() {
        if(this.defaultSoilAttr == '') return;
        this.soilTableData = [];
        this.soilTimeValue = [];
        this.soilDataValue = [];
        this.soilCurrentPage = 1;
        this.setEmptySoilOption();
        if(this.startTime === '' || this.endTime === '') return;
        let time = this.endTime - this.startTime;
        this.soilLoadFlg = true;
        //设置聚合时间间隔以及聚合函数
        if(time <= 1000 * 60 * 60 *24) {
          this.soilAgg = 'NONE';
          this.soilInterval = 0;
        } else {
          switch (this.soilAggSelect) {
            case "1":
              this.soilAgg = 'MAX';
              this.getSoilInterval();//设置聚合时间间隔
              break;
            case "2":
              this.soilAgg = 'MIN';
              this.getSoilInterval();//设置聚合时间间隔
              break;
            case "3":
              this.soilAgg = 'AVG';
              this.getSoilInterval();//设置聚合时间间隔
              break;
          }
        }
        this.getSoilHistory();//获取历史数据
      },

      /**
       * 设置时间间隔
       */
      getSoilInterval() {
        let intervalTime = (this.endTime - this.startTime) / (1000 * 60 * 60 * 24);
        if(intervalTime> 1 && intervalTime < 30) {
          switch (true) {
            case intervalTime >1 && intervalTime <= 3: //大于1天小于等于3天
              this.soilInterval = 1000 * 60 * 10;
              break;
            case intervalTime > 3 && intervalTime <=5: //大于3天小于等于5天
              this.soilInterval = 1000 * 60 * 15;
              break;
            case intervalTime > 5 && intervalTime <= 10: //大于5天小于等于10天
              this.soilInterval = 1000 * 60 * 30;
              break;
            case intervalTime > 10 && intervalTime <= 20: //大于10天小于等于20天
              this.soilInterval = 1000 * 60 * 60;
              break;
            case intervalTime > 20: //大于20天
              this.soilInterval = 1000 * 60 * 60 * 2;
              break;
          }
        } else if(intervalTime >= 30){// 30天以上 大于一个月设置时间间隔
          switch (true) {
            case intervalTime === 30: //等于30天
              this.soilInterval = 1000 * 60 * 60 * 2;
              break;
            case intervalTime > 30 && intervalTime <= 90: //大于1个月小于等于3个月
              this.soilInterval = 1000 * 60 * 60 * 5;
              break;
            case intervalTime > 90 && intervalTime <= 180: //大于3个月小于等于6个月
              this.soilInterval = 1000 * 60 * 60 * 10;
              break;
            case intervalTime > 180 && intervalTime <= 240: //大于6个月小于等于8个月
              this.soilInterval = 1000 * 60 * 60 * 12;
              break;
            case intervalTime > 240: //大于8个月
              this.soilInterval = 1000 * 60 * 60 * 24;
              break
          }
        }
      },

      /**
       * 数字表与折线图切换
       */
      soilChangeChart() {
        if(this.soilChartNum == 1) {
          this.soilChartNum = 2;
          this.soilChartName = '数字表';
          if(this.soilDataValue.length == 0) {
            this.setEmptySoilOption();//清空折线图
          } else {
            this.$nextTick(() => {
              this.setSoilOption();//刷新折线图
            })
          }
        } else {
          this.soilChartNum = 1;
          this.soilChartName = '折线图';
        }
      },

      /**
       * 获取历史数据
       */
      getSoilHistory() {
        //this.soilErrorNum++;
        getTimeDeviceHistory(this.soilDeviceId.entityType, this.soilDeviceId.id, this.defaultSoilAttr, this.startTime, this.endTime, this.soilInterval, this.soilAgg).then(response => {
          //this.soilErrorNum = 0;
          if(JSON.stringify(response.data) == "{}") {
            this.soilLoadFlg = false;
            return;
          }
          for(let obj in response.data) {
            for(let i = 0; i < response.data[obj].length; i++) {
              let tableJson = {};
              tableJson.ts = this.$commonFun.dateFormat(response.data[obj][i].ts);
              tableJson.name = this.$t(this.defaultSoilAttr).split(',')[0];
              let unit = this.$t(this.defaultSoilAttr).split(',')[1] === undefined ? '' : this.$t(this.defaultSoilAttr).split(',')[1];
              tableJson.value = parseFloat(response.data[obj][i].value).toFixed(2) + unit;
              this.soilTimeValue.push(this.$commonFun.dateFormat(response.data[obj][i].ts));
              this.soilDataValue.push(parseFloat(response.data[obj][i].value).toFixed(2));
              this.soilTableData.push(tableJson);
            }
          }
          this.$nextTick(() => {
            this.setSoilOption();
          });
          this.soilLoadFlg = false;
        }).catch(error => {
          // if(this.soilErrorNum > 4) {
          //   this.soilLoadFlg = false;
          //   this.soilErrorNum = 0;
          //   console.log("error", error);
          // } else {
          //   this.getSoilHistory();
          // }
          this.soilLoadFlg = false;
          console.log("error", error);
        })
      },

      /**
       * 切换条数
       * @param size
       */
      soilSizeChange(size) {
        this.soilPageSize = size;
      },

      /**
       * 切换页数
       * @param currentPage
       */
      soilCurrentChange(currentPage) {
        this.soilCurrentPage = currentPage;
      },

      /**
       * 折线图
       */
      setSoilOption() {
        let unit = this.$t(this.defaultSoilAttr).split(',')[1] === undefined ? '' : '(' + this.$t(this.defaultSoilAttr).split(',')[1] + ')';
        this.soilOption = {
          color: ['#FEC00A',],
          title: {
            text: this.$t(this.defaultSoilAttr).split(',')[0],
            left: 'center', //居中
            textStyle: {
              color: '#ffffff',
              fontSize: 22,
              lineHeight: 35,
              fontWeight: 'normal'
            }

          },
          tooltip: { //提示框
            trigger: 'axis',
            backgroundColor: "rgba(128, 128, 128, 0.5)",
            borderWidth: 1, //边框宽度设置1
            borderColor: "rgba(49, 73, 99, 1)", //设置边框颜色
            borderRadius: 4,
            padding: 5,
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'line' // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '1%',
            right: '5%',
            bottom: '5%',
            top:'10%',
            containLabel: true //grid区域是否包含坐标轴的刻度标签
          },
          xAxis: {
            name: '时间',
            type: 'category', //坐标轴类型。
            nameTextStyle:{
              color:'#fff',
              fontSize :14//字体大小
            },
            boundaryGap: true, //坐标轴两边留白策略
            data: this.soilTimeValue,
            offset: 8,
            axisLabel: {//坐标轴刻度标签的相关设置
              // rotate: 30,
              interval: 'auto',
              rotate: -50,
              show: true,
              textStyle: {
                color: '#fff',
                fontSize :12//字体大小
              },
            },
            axisLine:{//坐标轴轴线相关设置
              show :true,
              lineStyle:{
                // color:'#3a4650'// rgb(2,121,253)
                color: 'rgba(231, 244, 255, 0.2)'
              }
            },
            axisTick:{ //坐标轴刻度相关设置。
              show :false,
            }
          },
          yAxis: {
            name: '数值' + unit,
            type: 'value',
            nameTextStyle:{
              color:'#fff',
              fontSize :14//字体大小
            },
            show: true, //隐藏坐标
            axisLabel: { //y轴的坐标文字
              show: true, //不显示坐标控件
              textStyle: {
                color: '#fff', //文字的颜色
                fontSize :16//字体大小
              },
            },
            // max:this.max,//最大值
            // min:this.min,
            splitLine:{  //坐标在grid区域的分割线
              show: false,// 不显示网格
              lineStyle: { //设置分割线的样式(图表横线颜色)
                color: ['#153a8a'] //网格颜色
              }
            },
            axisLine:{//坐标轴轴线相关设置
              show :true,
              lineStyle:{
                color:'rgba(231, 244, 255, 0.2)'//#3a4650  rgb(2,121,253) #3a4650
              }
            },
            axisTick:{ //坐标轴刻度相关设置。
              show :false,
            },
          },
          series: [
            {
              type: 'line',
              data: this.soilDataValue,
              symbolSize: 10,
              smooth: true,
              animationDuration: 1000,
              lineStyle:{
                color:'#FEC00A'
              },
              tooltip: { //提示框
                trigger: 'axis',
                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                  type: 'line' // 默认为直线，可选为：'line' | 'shadow'
                },
              },
            },
          ],
          dataZoom: [
            {
              endValue: 15, //一次显示10个
              type: 'slider',//有滑动条
              show: true,//是否显示滑动条
              xAxisIndex: [0],//开始下标
              handleSize: 0,//滑动条的左右2个滑动条大小
              height: 20, //滑动条高度
              left: "0%",//左边距离
              right: "0%",//右边距离
              bottom: 0,//底部距离
              // borderColor: "#3a4650", //边框颜色
              borderColor: "#101f3e", //边框颜色
              fillerColor: "#4C7C98",//选中区域的背景色#345A7C#4878fe
              borderRadius: 5,//边框弧度
              //backgroundColor: "#1c2735",//未选区域中的背景色
              backgroundColor:'#0b2d4c',
              showDataShadow: false, //是否显示数据阴影
              showDetail:false,//拖动时是否显示数值
              realtime: true,// 是否实时更新
              filterMode: "filter",
            },
            {
              //左右滑动
              type: "inside",
              show: true,
              xAxisIndex: [0],
              start: 0,
              end: 100,
            }
          ]
        }
        this.soilCharts();
      },

      /**
       * 清空折线图
       */
      setEmptySoilOption() {
        this.soilOption = {};
        this.soilCharts();
      },

      /**
       * 折线图屏幕自适应
       */
     soilCharts() {
       document.getElementById("soilChart").removeAttribute("_echarts_instance_");
       let chartOption = this.$echarts.init(document.getElementById('soilChart'));
       chartOption.setOption(this.soilOption);

       //图表自适应
       window.addEventListener("resize",function(){
         chartOption.resize()  // myChart 是实例对象
       })
     },

      /**
       * 导出
       */
      soilExportData() {
        let that = this;
        if(that.soilTableData.length == 0) {
          that.$message({
            showClose: true,
            type:"warning",
            message: '未查询到数据',
            duration: 5000
          });
          return;
        }
        const {export_json_to_excel} = require('../../vendor/Export2Excel')
        const tHeader = ["名称", "时间", "值"];
        const filterVal = ['name', 'ts', 'value'];
        const list = that.soilTableData;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, this.$t(this.defaultSoilAttr).split(',')[0] + "_历史数据");
      },

      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]));
      }
    }
  }
</script>

<style lang="less">
  @import "../less/SoilHistoryData";
</style>

<style>
  .soilHistory-data-content::-webkit-scrollbar {
    display: none;
  }

  .red-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    margin-right: 5px;
  }

  .green-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: green;
    border-radius: 50%;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/SoilHistoryData.vue